<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/M0hH1b/tc-custom/9781609943158.jpg?1705766093883" alt="This image is the cover for the book America As Empire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">America As Empire
      </h1>
      <p class="bookDescription body article font2">
        <p>In America as Empire, Jim Garrison urges us to face up to the complexities and responsibilities inherent in the indisputable fact that America is now the world's single preeminent power. "America", Garrison writes, "has become what it was founded not to be: established as a haven for those fleeing the abuse of power, it has attained and now wields near absolute power. It has become an empire." Garrison traces the roots of the American empire to the very beginnings of the republic, in particular to the historic willingness of United States' to use military might in the defense of two consistent --- if sometimes contradictory --- foreign policy objectives: protection of American commercial interests and promotion of democracy. How long can the American empire last? Garrison looks at American history within the context of the rise and fall of empires and argues that the U. S. can gain important insights into durability from the Romans. He details the interplay between military power, political institutions, and legal structures that enabled the Roman empire at it's apogee to last for longer than America has as a country. But the real question is, what kind of empire can and should America be? As the sole superpower, America must lead in shaping a new global order, just as after World War II Roosevelt and Truman took the lead in shaping a new international order. That international order is now crumbling under the pressures of globalization, persistent poverty, terrorism and fundamentalism. Garrison outlines the kinds of cooperative global structures America must promote if its empire is to leave a lasting legacy of greatness. Garrison calls for Americans to consciously see themselves as a transitional empire, one whose task is not to dominate but to catalyze the next generation of global governance mechanisms that would make obsolete the need for empire. If this is done, America could be the final empire.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Garrison
      </h2>
      
      <p class="authorDescription body article">James Garrison</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5cb432d1